
import { useState } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-md relative">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <div className="text-left">
              <h1 className="text-sm font-bold text-[#2c5f7c] leading-relaxed" style={{ fontFamily: 'Pacifico, serif' }}>
                <span className="block">医療法人社団ゆうまデンタルクリニック</span>
                <span className="block">LIOデンタルクリニック</span>
                <span className="block">いくの歯科医院</span>
              </h1>
              <p className="text-[#8b7355] text-sm">インプラントサイト</p>
            </div>
          </div>

          {/* Desktop - Contact Info and Schedule */}
          <div className="hidden lg:flex items-center space-x-8">
            <div className="flex flex-col space-y-1 text-sm">
              <div className="flex items-center">
                <i className="ri-map-pin-line text-[#8b7355] mr-2 w-4 h-4 flex items-center justify-center"></i>
                <span className="text-slate-700">LIOデンタルクリニック：神戸市東灘区深江南町1-12-16</span>
              </div>
              <div className="flex items-center">
                <i className="ri-map-pin-line text-[#8b7355] mr-2 w-4 h-4 flex items-center justify-center"></i>
                <span className="text-slate-700">いくの歯科医院：大阪市生野区勝山北1-3-19</span>
              </div>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-[#2c5f7c] p-2"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4 mt-4">
              <div className="flex flex-col space-y-2 text-sm">
                <div className="flex items-center">
                  <i className="ri-map-pin-line text-[#8b7355] mr-2 w-4 h-4 flex items-center justify-center"></i>
                  <span className="text-slate-700">LIOデンタルクリニック：神戸市東灘区深江南町1-12-16</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-map-pin-line text-[#8b7355] mr-2 w-4 h-4 flex items-center justify-center"></i>
                  <span className="text-slate-700">いくの歯科医院：大阪市生野区勝山北1-3-19</span>
                </div>
              </div>
              <div className="pt-4">
                <p className="text-[#8b7355] text-sm mb-2">お電話でのご予約</p>
                <a href="tel:078-453-0828" className="text-[#2c5f7c] text-lg font-bold block mb-4 cursor-pointer">
                  078-453-0828
                </a>
                <a href="#contact" className="bg-[#c8a882] text-white px-6 py-3 rounded-md font-bold inline-block cursor-pointer whitespace-nowrap">
                  お問い合わせ
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
